/* unplugin-vue-components disabled */import script from "./WebAppPop.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAppPop.vue?vue&type=script&setup=true&lang=js"

import "./WebAppPop.vue?vue&type=style&index=0&id=6b18281e&lang=less"

const __exports__ = script;

export default __exports__